import { Modal, Toast } from 'antd-mobile';

import { isAndroid, isIOS } from './device';
import { getAuthInfo } from './tools';

export function waitBridge(time = 10) {
  let t = time;
  let handler: ReturnType<typeof setInterval>;
  function check(resolve: (n: boolean) => void) {
    if (!t) {
      handler && clearInterval(handler);
      return resolve(false);
    }
    if (window.bridge) {
      handler && clearInterval(handler);
      return resolve(true);
    }
  }
  return new Promise((resolve) => {
    check(resolve);
    handler = setInterval(() => {
      t = t - 1;
      check(resolve);
    }, 200);
  });
}

function callHandler(name: string, params: any = {}, callback: any = () => {}) {
  window.bridge?.callHandler(name, params, callback);
}

function registerHandler(name: string, handler: any = () => {}) {
  window.bridge?.registerHandler(name, handler);
}

export async function getUserInfo(): Promise<IUserInfo | undefined> {
  let auth = getAuthInfo();
  if (!window.bridge && (isAndroid || isIOS) && !auth) {
    await waitBridge();
  }
  const isInApp = !!window.bridge;
  try {
    if (isInApp) {
      auth = await new Promise((resolve) => callHandler('getUserInfo', {}, resolve));
    }
  } catch (e) {
    return;
  }

  return auth;
}

export function goBack() {
  const isInApp = !!window.bridge;
  if (isInApp) {
    callHandler('goBack');
    return;
  }

  window.history.back();
}

export function exit() {
  const isInApp = !!window.bridge;
  if (isInApp) {
    callHandler('exit');
    return;
  }

  window.history.back();
}

export function toast(msg: string) {
  const isInApp = !!window.bridge;
  if (isInApp) {
    callHandler('showToast', { msg });
    return;
  }

  Toast.show({ content: msg });
}

export function alert(msg: string) {
  const isInApp = !!window.bridge;
  if (isInApp) {
    return new Promise((resolve) => {
      const handler = setTimeout(() => resolve(false), 30 * 60 * 1000);
      registerHandler('confirmAck', (confirm: boolean) => {
        clearTimeout(handler);
        resolve(confirm);
      });
      callHandler('showAlert', { msg });
    });
  }

  return Modal.confirm({
    content: msg,
  });
}

export function showAlertWithWarn(title: string, msg: string, warn: string) {
  const isInApp = !!window.bridge;
  if (isInApp) {
    return new Promise((resolve) => {
      const handler = setTimeout(() => resolve(false), 30 * 60 * 1000);
      registerHandler('confirmAck', (confirm: boolean) => {
        clearTimeout(handler);
        resolve(confirm);
      });
      callHandler('showAlertWithWarn', { title, msg, warn });
    });
  }

  return Modal.confirm({ title, content: msg });
}

export function selectPhoto(size: number = 100): Promise<string | null> {
  const isInApp = !!window.bridge;
  if (isInApp) {
    return new Promise((resolve) => {
      registerHandler('uploadFileAck', ({ url }: { url: string }) => resolve(url));
      callHandler('popUploadFile', { fileType: 0, size });
    });
  }

  return Promise.resolve(null);
}

export function selectVideo(size: number = 100): Promise<Video | null> {
  const isInApp = !!window.bridge;
  if (isInApp) {
    return new Promise((resolve) => {
      registerHandler('uploadFileAck', (result: Video) => resolve(result));
      callHandler('popUploadFile', { fileType: 1, size });
    });
  }

  return Promise.resolve(null);
}

// export function takePhoto(): Promise<{ url: string, coverUrl: string }> {
//   const isInApp = !!window.bridge;
//   if (isInApp) {
//     return new Promise((resolve) => {
//       registerHandler('takePhotoAck', (result: { url: string, coverUrl: string }) => resolve(result));
//       callHandler('showTakePhotoPopView');
//     });
//   }

//   return Promise.resolve();
// }

export function setBusinessStatus(type: number) {
  const isInApp = !!window.bridge;
  if (isInApp) {
    callHandler('setBusinessInfo', { type });
  }
}

export function openPage(pageId: number, uid?: number, extra?: Record<string, any>) {
  const isInApp = !!window.bridge;
  if (isInApp) {
    callHandler('navigationTo', { pageId, uid, ...extra });
  }
}

export function openLink(url: string) {
  const isInApp = !!window.bridge;
  if (isInApp) {
    callHandler('navigationToWebPage', { url });
  } else {
    window.location.href = url;
  }
}

/**
 *
 * @param type 1 :公会申请消息已读
 */
export function readedMessage(type: number) {
  const isInApp = !!window.bridge;
  if (isInApp) {
    callHandler('readedMessage', { type });
  }
}

//数据上报代理
export function reportTrackData(data: {
  eventName: string;
  properties: { title: string; msg: string; warn: string };
}) {
  const isInApp = !!window.bridge;
  if (isInApp) {
    callHandler('reportTrackData', data);
  }
}
